export const tagsModalStyles = {
  container: {
    display: 'flex',
    width: '430px',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    borderBottom: '1px solid #F3F4F9',
    padding: '40px 40px 20px 40px',
    position: 'relative',
  },
  title: {
    fontFamily: 'Inter',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '136%',
    color: '#23252F',
  },
  postContainer: {
    width: 'calc(100% - 3px)',
    display: 'flex',
    padding: '32px 40px',
    maxHeight: '600px',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      border: 'none',
      width: '11px',
      height: '11px',
      padding: '5px 0',
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: '#fff',
      border: 'none',
      height: '10px',
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#D4D6E0',
      width: '2px',
      borderRadius: '6px',
      cursor: 'pointer',
    },
  },
  closeButtonContainer: {
    width: '16px',
    height: '16px',
    display: 'flex',
    position: 'absolute',
    right: '16px',
    top: '16px',
  },
  closeButton: {
    width: '20px',
    height: '20px',
    padding: 0,
    '& svg': {
      width: '20px',
      height: '20px',
    },
  },
};
